

/* NO iOS ZOOM on small-font inputs — includes generic submit buttons */
/* NOAH — prevent iPhone auto-zoom on small form fields */

(() => {
  const ua = navigator.userAgent || "";

  const isiOS =
    /iP(ad|hone|od)/.test(ua) ||
    (ua.includes("Mac") && navigator.maxTouchPoints > 1);

  if (!isiOS) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute("content") || "";

  let restoreTimer = null;

  const isFormField = (target) =>
    target?.closest?.("input, textarea, select");

  function lockZoom() {
    clearTimeout(restoreTimer);

    const cleaned = original
      .replace(/,\s*maximum-scale\s*=\s*[^,]+/gi, "")
      .replace(/,\s*user-scalable\s*=\s*[^,]+/gi, "");

    meta.setAttribute(
      "content",
      `${cleaned}, maximum-scale=1, user-scalable=no`
    );
  }

  function restoreZoom(delay = 400) {
    clearTimeout(restoreTimer);

    restoreTimer = setTimeout(() => {
      meta.setAttribute("content", original);
    }, delay);
  }

  /*
    Tap path:
    lock BEFORE Safari focuses the small input.
  */
  ["pointerdown", "touchstart"].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        if (!isFormField(event.target)) return;

        lockZoom();

        /*
          Restore shortly after focus has settled.
          Normal pinch zoom is therefore not permanently disabled.
        */
        restoreZoom();
      },
      true
    );
  });

  /*
    Keyboard/autofocus/programmatic-focus fallback.
  */
  document.addEventListener(
    "focusin",
    (event) => {
      if (!isFormField(event.target)) return;

      lockZoom();
      restoreZoom();
    },
    true
  );

  document.addEventListener(
    "focusout",
    (event) => {
      if (!isFormField(event.target)) return;

      clearTimeout(restoreTimer);
      meta.setAttribute("content", original);
    },
    true
  );
})();





/* newsletter popup test  */ 
(() => {
  const modal = document.querySelector('[data-noah-subscribe-modal]');
  if (!modal) return;

  const input = modal.querySelector('#NoahSubscribeEmail');
  const closeBtns = modal.querySelectorAll('[data-noah-subscribe-close]');

  const setOpen = (open) => {
    modal.hidden = !open;
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('noah-subscribe-open', open);
    document.body.classList.toggle('noah-subscribe-open', open);

    if (open) {
      // small delay so focus works reliably on iOS
      setTimeout(() => input && input.focus(), 50);
    } else {
      // remove hash without jumping
      if (location.hash === '#noah-subscribe') {
        history.replaceState(null, '', location.pathname + location.search);
      }
    }
  };

  const open = () => setOpen(true);
  const close = () => setOpen(false);

  // Click footer link (or any link) pointing to the hash
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#noah-subscribe"], a[href="/#noah-subscribe"]');
    if (!a) return;
    e.preventDefault();
    open();
  });

  // Close actions
  closeBtns.forEach((btn) => btn.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Open if loaded with hash
  if (location.hash === '#noah-subscribe') open();

  // Open after submit if success/error happened (page reload)
  if (modal.dataset.openOnLoad === 'true') open();
})();














/* NOAH — SYNCED COLOR ENGINE
   Horizon 4.2+
   Site title + PDS footer + cart dot + password + checkout
*/

(() => {
  if (window.__noahO6SyncV3) return;
  window.__noahO6SyncV3 = true;

  // ---- Palette ----
  const COLORS = [
    "#ae401c",
    "#8c7f74",
    "#685d5d",
    "#13c4d6",
    "#d9a300",
    "#cfaacf",
    "#004e80",
    "#23834B"
  ];

  // ---- Timing ----
  const CHANGE_EVERY_MS = 7000;
  const FADE_MS = 2500;

  // ---- Session continuity ----
  const SESSION_KEY = "noah-o6-sync-v2";

  const root = document.documentElement;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  // ---- Targets ----

  // These use --o6-bg-a / --o6-next-a + .is-fading.
  const FADE_TARGETS = [
    ".o6-footer-bar",
    '.header-logo > [data-testid="header-logo"]',
    '.header-logo > [data-testid="header-logo-inverse"]',
    ".o6-sync-bg"
  ];

  // These animate their background directly.
 const SOLID_BG_TARGETS = [
  ".o6-password-logo",
  ".cart__ctas .cart__checkout-button",
  ".add-to-cart-button",
  ".cart-items__empty-button"
];

const FORCE_WHITE_TEXT_ON = [
  ".o6-password-logo",
  ".cart__ctas .cart__checkout-button",
  ".add-to-cart-button",
  ".cart-items__empty-button"
];

  // ---- State ----
  let lastA = null;
  let lastB = null;

  let loopTimer = null;
  let fadeTimer = null;
  let liveColorFrame = null;

  let observer = null;
  let pendingInit = false;

  let isTransitioning = false;

  let transitionStartAt = 0;
  let transitionEndsAt = 0;
  let transitionTargetA = null;
  let transitionTargetB = null;
  let nextTickAt = 0;

  // ---- General helpers ----
  function randFrom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function elements(selectors) {
    const found = new Set();

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        found.add(el);
      });
    });

    return Array.from(found);
  }

  function getVar(name) {
    return getComputedStyle(root)
      .getPropertyValue(name)
      .trim();
  }

  function setFadeDuration(ms) {
    root.style.setProperty("--o6-fade-ms", `${ms}ms`);
  }

  function setBase(a, b) {
    root.style.setProperty("--o6-bg-a", a);
    root.style.setProperty("--o6-bg-b", b);

    lastA = a;
    lastB = b;
  }

  function setNext(a, b) {
    root.style.setProperty("--o6-next-a", a);
    root.style.setProperty("--o6-next-b", b);
  }

  function setLiveColor(color) {
    root.style.setProperty("--o6-live-a", color);
  }

  function pickNextPair() {
    const aPool = lastA
      ? COLORS.filter((color) => color !== lastA)
      : COLORS.slice();

    const a = randFrom(aPool);

    const bPool = COLORS.filter((color) => color !== a);
    const b = randFrom(bPool);

    return [a, b];
  }

    // ---- Selection colors — Amatona behavior ----

  const SELECTION_INTERVAL_MS = 250;

  let selectionQueue = [];
  let lastSelectionColor = null;
  let selectionTimer = null;

  function shuffleSelectionColors(array) {
    return array
      .map((value) => ({
        value,
        sort: Math.random()
      }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  }

  function setNextSelectionColor() {
    if (selectionQueue.length === 0) {
      selectionQueue = shuffleSelectionColors(COLORS);

      if (
        selectionQueue.length > 1 &&
        selectionQueue[0] === lastSelectionColor
      ) {
        const first = selectionQueue.shift();
        selectionQueue.push(first);
      }
    }

    const nextColor = selectionQueue.shift();
    lastSelectionColor = nextColor;

    root.style.setProperty(
      "--selection-accent-color",
      nextColor
    );
  }

  function startSelectionColors() {
    if (selectionTimer !== null) return;

    selectionQueue = shuffleSelectionColors(COLORS);

    setNextSelectionColor();

    selectionTimer = setInterval(
      setNextSelectionColor,
      SELECTION_INTERVAL_MS
    );
  }

  // ---- Color interpolation ----
  function parseColor(value) {
    if (!value) return null;

    const color = value.trim();

    if (/^#[0-9a-f]{3}$/i.test(color)) {
      return {
        r: parseInt(color[1] + color[1], 16),
        g: parseInt(color[2] + color[2], 16),
        b: parseInt(color[3] + color[3], 16)
      };
    }

    if (/^#[0-9a-f]{6}$/i.test(color)) {
      return {
        r: parseInt(color.slice(1, 3), 16),
        g: parseInt(color.slice(3, 5), 16),
        b: parseInt(color.slice(5, 7), 16)
      };
    }

    if (color.startsWith("rgb")) {
      const numbers = color.match(/[\d.]+/g);

      if (numbers && numbers.length >= 3) {
        return {
          r: Number(numbers[0]),
          g: Number(numbers[1]),
          b: Number(numbers[2])
        };
      }
    }

    return null;
  }

  function mixColor(from, to, progress) {
    const a = parseColor(from);
    const b = parseColor(to);

    if (!a || !b) {
      return progress >= 0.5 ? to : from;
    }

    const t = Math.max(0, Math.min(1, progress));

    const r = Math.round(
      a.r + (b.r - a.r) * t
    );

    const g = Math.round(
      a.g + (b.g - a.g) * t
    );

    const blue = Math.round(
      a.b + (b.b - a.b) * t
    );

    return `rgb(${r}, ${g}, ${blue})`;
  }

  // ---- Read actual visible fade progress ----
  // ---- Read fade progress directly from the JS clock ----

function easeInOut(progress) {
  const x1 = 0.42;
  const y1 = 0;
  const x2 = 0.58;
  const y2 = 1;

  const cx = 3 * x1;
  const bx = 3 * (x2 - x1) - cx;
  const ax = 1 - cx - bx;

  const cy = 3 * y1;
  const by = 3 * (y2 - y1) - cy;
  const ay = 1 - cy - by;

  const sampleX = (t) =>
    ((ax * t + bx) * t + cx) * t;

  const sampleY = (t) =>
    ((ay * t + by) * t + cy) * t;

  const sampleDerivativeX = (t) =>
    (3 * ax * t + 2 * bx) * t + cx;

  function solveX(x) {
    let t = x;

    // Newton-Raphson
    for (let i = 0; i < 8; i++) {
      const difference = sampleX(t) - x;

      if (Math.abs(difference) < 0.000001) {
        return t;
      }

      const derivative = sampleDerivativeX(t);

      if (Math.abs(derivative) < 0.000001) {
        break;
      }

      t -= difference / derivative;
    }

    // Binary-search fallback
    let low = 0;
    let high = 1;
    t = x;

    for (let i = 0; i < 20; i++) {
      const value = sampleX(t);

      if (Math.abs(value - x) < 0.000001) {
        return t;
      }

      if (value < x) {
        low = t;
      } else {
        high = t;
      }

      t = (low + high) / 2;
    }

    return t;
  }

  return sampleY(solveX(progress));
}

function getVisibleFadeProgress() {
  if (
    !isTransitioning ||
    !transitionStartAt ||
    transitionEndsAt <= transitionStartAt
  ) {
    return 0;
  }

  const raw =
    (Date.now() - transitionStartAt) /
    (transitionEndsAt - transitionStartAt);

  const clamped = Math.max(
    0,
    Math.min(1, raw)
  );

  return easeInOut(clamped);
}


  function getVisiblePair() {
    const baseA =
      getVar("--o6-bg-a") ||
      lastA ||
      COLORS[0];

    const baseB =
      getVar("--o6-bg-b") ||
      lastB ||
      baseA;

    if (!isTransitioning) {
      return [baseA, baseB];
    }

    const nextA =
      getVar("--o6-next-a") ||
      transitionTargetA ||
      baseA;

    const nextB =
      getVar("--o6-next-b") ||
      transitionTargetB ||
      baseB;

    const progress =
      getVisibleFadeProgress();

    return [
      mixColor(baseA, nextA, progress),
      mixColor(baseB, nextB, progress)
    ];
  }

  // ---- Live color ----
  function stopLiveColorLoop() {
    if (liveColorFrame) {
      cancelAnimationFrame(liveColorFrame);
      liveColorFrame = null;
    }
  }

  function updateLiveColor() {
    if (!isTransitioning) {
      setLiveColor(
        getVar("--o6-bg-a") ||
          lastA ||
          COLORS[0]
      );

      liveColorFrame = null;
      return;
    }

    const baseA =
      getVar("--o6-bg-a") ||
      lastA ||
      COLORS[0];

    const nextA =
      getVar("--o6-next-a") ||
      transitionTargetA ||
      baseA;

    const progress =
      getVisibleFadeProgress();

    setLiveColor(
      mixColor(
        baseA,
        nextA,
        progress
      )
    );

    liveColorFrame =
      requestAnimationFrame(
        updateLiveColor
      );
  }

  function startLiveColorLoop() {
    stopLiveColorLoop();

    liveColorFrame =
      requestAnimationFrame(
        updateLiveColor
      );
  }

  // ---- Fade classes ----
  function setFadeClass(active) {
    elements(FADE_TARGETS).forEach((el) => {
      el.classList.toggle(
        "is-fading",
        active
      );
    });
  }

  // ---- Solid target animation ----
  function animateBackground(
    el,
    toValue,
    duration
  ) {
    try {
      if (el.__noahO6BgAnim) {
        el.__noahO6BgAnim.cancel();
      }

      const fromValue =
        getComputedStyle(el)
          .backgroundColor;

      const animation = el.animate(
        [
          {
            backgroundColor:
              fromValue
          },
          {
            backgroundColor:
              toValue
          }
        ],
        {
          duration,
          easing: "ease-in-out",
          fill: "forwards"
        }
      );

      el.__noahO6BgAnim = animation;

      animation.onfinish = () => {
        el.style.backgroundColor =
          toValue;

        el.__noahO6BgAnim = null;
      };
    } catch {
      el.style.transition =
        `background-color ${duration}ms ease-in-out`;

      el.style.backgroundColor =
        toValue;
    }
  }

  // ---- Newly injected Shopify elements ----
  function initNewTargets() {
    const baseA =
      getVar("--o6-live-a") ||
      getVar("--o6-bg-a") ||
      lastA ||
      COLORS[0];

    elements(
      SOLID_BG_TARGETS
    ).forEach((el) => {
      if (
        el.dataset.o6BgInit === "1"
      ) {
        return;
      }

      el.dataset.o6BgInit = "1";

      el.style.backgroundColor =
        baseA;
    });

    elements(
      FORCE_WHITE_TEXT_ON
    ).forEach((el) => {
      if (
        el.dataset.o6WhiteInit === "1"
      ) {
        return;
      }

      el.dataset.o6WhiteInit = "1";

      el.style.color = "#fff";
      el.style.opacity = "1";
    });
  }

  // ---- Session storage ----
  function validColor(value) {
    return (
      typeof value === "string" &&
      value.length > 0 &&
      CSS.supports(
        "color",
        value
      )
    );
  }

  function readSessionState() {
    try {
      const raw =
        sessionStorage.getItem(
          SESSION_KEY
        );

      if (!raw) return null;

      const state =
        JSON.parse(raw);

      if (
        !state ||
        !validColor(state.a) ||
        !validColor(state.b)
      ) {
        return null;
      }

      return state;
    } catch {
      return null;
    }
  }

  function saveSessionState(state) {
    try {
      sessionStorage.setItem(
        SESSION_KEY,
        JSON.stringify(state)
      );
    } catch {}
  }

  // Save exactly what is visible
  // when leaving the page.
  function snapshotVisibleState() {
    if (!lastA || !lastB) return;

    const [visibleA, visibleB] =
      getVisiblePair();

    if (
      isTransitioning &&
      transitionTargetA &&
      transitionTargetB &&
      transitionEndsAt > Date.now()
    ) {
      saveSessionState({
        a: visibleA,
        b: visibleB,

        targetA:
          transitionTargetA,

        targetB:
          transitionTargetB,

        fadeEndsAt:
          transitionEndsAt,

        nextAt:
          transitionEndsAt +
          CHANGE_EVERY_MS
      });

      return;
    }

    saveSessionState({
      a: visibleA,
      b: visibleB,

      targetA: null,
      targetB: null,
      fadeEndsAt: null,

      nextAt:
        nextTickAt ||
        Date.now() +
          CHANGE_EVERY_MS
    });
  }

  // ---- Loop ----
  function stopLoop() {
    if (loopTimer) {
      clearTimeout(loopTimer);
      loopTimer = null;
    }
  }

  function stopFadeTimer() {
    if (fadeTimer) {
      clearTimeout(fadeTimer);
      fadeTimer = null;
    }
  }

  function scheduleNext(ms) {
    stopLoop();

    const delay =
      Math.max(0, ms);

    nextTickAt =
      Date.now() + delay;

    saveSessionState({
      a: lastA,
      b: lastB,

      targetA: null,
      targetB: null,
      fadeEndsAt: null,

      nextAt:
        nextTickAt
    });

    loopTimer =
      setTimeout(
        tick,
        delay
      );
  }

  function beginTransition(
    targetA,
    targetB,
    duration = FADE_MS
  ) {
    stopFadeTimer();

    const actualDuration =
      Math.max(1, duration);

    isTransitioning = true;

    transitionStartAt =
      Date.now();

    transitionEndsAt =
      transitionStartAt +
      actualDuration;

    transitionTargetA =
      targetA;

    transitionTargetB =
      targetB;

    setFadeDuration(
      actualDuration
    );

    setNext(
      targetA,
      targetB
    );

    saveSessionState({
      a: lastA,
      b: lastB,

      targetA,
      targetB,

      fadeEndsAt:
        transitionEndsAt,

      nextAt:
        transitionEndsAt +
        CHANGE_EVERY_MS
    });

    requestAnimationFrame(() => {
      setFadeClass(true);
      startLiveColorLoop();
    });

    elements(
      SOLID_BG_TARGETS
    ).forEach((el) => {
      animateBackground(
        el,
        targetA,
        actualDuration
      );
    });

    elements(
      FORCE_WHITE_TEXT_ON
    ).forEach((el) => {
      el.style.color = "#fff";
      el.style.opacity = "1";
    });

    fadeTimer = setTimeout(() => {
      setBase(
        targetA,
        targetB
      );

      setNext(
        targetA,
        targetB
      );

      setLiveColor(targetA);
      stopLiveColorLoop();

      setFadeClass(false);

      setFadeDuration(
        FADE_MS
      );

      isTransitioning = false;

      transitionStartAt = 0;
      transitionEndsAt = 0;

      transitionTargetA = null;
      transitionTargetB = null;

      fadeTimer = null;

      scheduleNext(
        CHANGE_EVERY_MS
      );
    }, actualDuration);
  }

  function tick() {
    if (document.hidden) {
      scheduleNext(
        CHANGE_EVERY_MS
      );

      return;
    }

    initNewTargets();

    const [a, b] =
      pickNextPair();

    beginTransition(
      a,
      b,
      FADE_MS
    );
  }

  // ---- Start / restore ----
  function start() {
    setFadeDuration(
      FADE_MS
    );

    const saved =
      readSessionState();

    const now =
      Date.now();

    if (!saved) {
      const initA =
        randFrom(COLORS);

      const initB =
        randFrom(
          COLORS.filter(
            (color) =>
              color !== initA
          )
        );

      setBase(
        initA,
        initB
      );

      setNext(
        initA,
        initB
      );

      setLiveColor(
        initA
      );

      initNewTargets();

      if (prefersReduced) return;

      scheduleNext(0);

      return;
    }

    let initA = saved.a;
    let initB = saved.b;

    // A transition was happening
    // on the previous page.
    if (
      validColor(
        saved.targetA
      ) &&
      validColor(
        saved.targetB
      ) &&
      Number.isFinite(
        saved.fadeEndsAt
      )
    ) {
      // Fade finished during load.
      if (
        saved.fadeEndsAt <= now
      ) {
        initA =
          saved.targetA;

        initB =
          saved.targetB;

        setBase(
          initA,
          initB
        );

        setNext(
          initA,
          initB
        );

        setLiveColor(
          initA
        );

        initNewTargets();

        if (
          prefersReduced
        ) {
          return;
        }

        const delay =
          Number.isFinite(
            saved.nextAt
          )
            ? Math.max(
                0,
                saved.nextAt -
                  now
              )
            : CHANGE_EVERY_MS;

        scheduleNext(
          delay
        );

        return;
      }

      // Resume same transition
      // from exact visible color.
      setBase(
        initA,
        initB
      );

      setNext(
        initA,
        initB
      );

      setLiveColor(
        initA
      );

      initNewTargets();

      if (
        prefersReduced
      ) {
        return;
      }

      beginTransition(
        saved.targetA,
        saved.targetB,
        saved.fadeEndsAt -
          now
      );

      return;
    }

    // Stable color between transitions.
    setBase(
      initA,
      initB
    );

    setNext(
      initA,
      initB
    );

    setLiveColor(
      initA
    );

    initNewTargets();

    if (prefersReduced) return;

    const delay =
      Number.isFinite(
        saved.nextAt
      )
        ? Math.max(
            0,
            saved.nextAt -
              now
          )
        : 0;

    scheduleNext(
      delay
    );
  }

  // ---- Shopify DOM updates ----
  function observeDom() {
    if (observer) return;

    observer =
      new MutationObserver(() => {
        if (pendingInit) return;

        pendingInit = true;

        setTimeout(() => {
          pendingInit = false;
          initNewTargets();
        }, 120);
      });

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  // ---- Resume ----
  function handleResume() {
    if (
      prefersReduced ||
      document.hidden
    ) {
      return;
    }

    initNewTargets();
  }

  // ---- Boot ----
  function boot() {
  start();
  startSelectionColors();
  observeDom();
}

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  document.addEventListener(
    "shopify:section:load",
    initNewTargets
  );

  document.addEventListener(
    "visibilitychange",
    handleResume
  );

  window.addEventListener(
    "pageshow",
    handleResume
  );

  // Capture exact visible color
  // before leaving the document.
  window.addEventListener(
    "pagehide",
    snapshotVisibleState
  );
})();






/* NOAH — simplify + gently reveal custom property character count */
(() => {
  const SELECTOR =
    'label[for^="CustomProperty-"] .__character-count';

  function cleanCount(count) {
    if (!count) return;

    count.dataset.template = "[current]/[max]";

    const cleaned = count.textContent
      .replace(/\s*characters used\s*/i, "")
      .trim();

    if (count.textContent.trim() !== cleaned) {
      count.textContent = cleaned;
    }
  }

  function initCount(count) {
    if (!count || count.dataset.noahCountReady === "true") return;

    count.dataset.noahCountReady = "true";

    cleanCount(count);

    const observer = new MutationObserver(() => {
      cleanCount(count);
    });

    observer.observe(count, {
      childList: true,
      characterData: true,
      subtree: true
    });

    setTimeout(() => {
      count.classList.add("noah-count-visible");
    }, 200);
  }

  function initAll(root = document) {
    root.querySelectorAll?.(SELECTOR).forEach(initCount);
  }

  initAll();

  const pageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches?.(SELECTOR)) {
          initCount(node);
        }

        initAll(node);
      });
    });
  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();






















/* NOAH — Continue Shopping closes drawer + keeps normal link */
document.addEventListener("click", (event) => {
  const button = event.target.closest(
    "a.button.cart-items__empty-button"
  );

  if (!button) return;

  const drawer = button.closest("#cart-drawer");
  const closeButton = drawer?.querySelector(
    ".theme-drawer__close-button"
  );

  closeButton?.click();
});
























/* PAS: light navigation over media or colored page backgrounds */
/* PAS navigation: black over cream, white over media/color. */
/* PAS: independently check each nav item's visible midpoint. */
(() => {
  if (window.pasAdaptiveNavStarted) return;
  window.pasAdaptiveNavStarted = true;

  function start() {
    const header = document.querySelector('#header-component');
    const main = document.querySelector('#MainContent');
    if (!header || !main) return;

    const selector = [
      'header-menu .menu-list__link',
      '.header__navigation-bar-row .menu-list__item',
      'summary.header__icon--summary',
      '[data-testid="cart-drawer-trigger"]'
    ].join(',');

    let controls = [];
    let media = [];
    let needsRefresh = true;
    let reportedError = false;

    function refresh() {
      controls = Array.from(header.querySelectorAll(selector));
      media = Array.from(main.querySelectorAll('img, video'));
      needsRefresh = false;
    }

    function covers(rect, x, y) {
      return rect.width > 0 && rect.height > 0 &&
        x >= rect.left && x <= rect.right &&
        y >= rect.top && y <= rect.bottom;
    }

    function coloredBackground(element) {
      for (
        let node = element;
        node && main.contains(node);
        node = node.parentElement
      ) {
        const style = getComputedStyle(node);

        if (style.backgroundImage !== 'none') return true;

        const values = style.backgroundColor.match(/[\d.]+/g);
        if (!values || values.length < 3) continue;

        const [r, g, b, alpha = 1] = values.map(Number);
        if (alpha < 0.9) continue;

        // Normal PAS background: #f4f0ec.
        return Math.max(
          Math.abs(r - 244),
          Math.abs(g - 240),
          Math.abs(b - 236)
        ) > 12;
      }

      return false;
    }

    function update() {
      if (needsRefresh) refresh();

      const points = controls.map(control => {
        const visiblePart = control.querySelector(
          '.menu-list__link-title, svg'
        ) || control;

        const rect = visiblePart.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;

        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;

        if (
          x < 0 || y < 0 ||
          x >= innerWidth || y >= innerHeight
        ) return null;

        return { control, x, y };
      }).filter(Boolean);

      if (!points.length) return;

      const panelOpen =
  header.querySelector('details[open]') ||
  document.querySelector('dialog[open]');

      const bounds = media.flatMap(element => {
        const rect = element.getBoundingClientRect();

        // Only inspect media that could be behind a nav item.
        if (!points.some(point => covers(rect, point.x, point.y))) {
          return [];
        }

        const style = getComputedStyle(element);
        if (
          style.display === 'none' ||
          style.visibility === 'hidden'
        ) return [];

        return [rect];
      });

      points.forEach(({ control, x, y }) => {
        let light = false;

        {
          const underneath = document.elementsFromPoint(x, y)
            .find(element => main.contains(element));

          light = Boolean(underneath && (
            bounds.some(rect => covers(rect, x, y)) ||
            coloredBackground(underneath)
          ));
        }

        const color = light ? '#fff' : '#000';

        if (!control.classList.contains('pas-adaptive-nav')) {
          control.classList.add('pas-adaptive-nav');
        }

        if (
          control.style.getPropertyValue('--pas-nav-color') !== color
        ) {
          control.style.setProperty('--pas-nav-color', color);
        }
      });
    }

    // Refresh cached elements when Shopify adds/removes content.
    const observer = new MutationObserver(() => {
      needsRefresh = true;
    });

    observer.observe(main, { childList: true, subtree: true });
    observer.observe(header, { childList: true, subtree: true });

    function tick() {
      // Queue the next check first so an error cannot freeze the loop.
      requestAnimationFrame(tick);
      if (document.hidden) return;

      try {
        update();
      } catch (error) {
        needsRefresh = true;

        if (!reportedError) {
          console.warn('PAS navigation color check:', error);
          reportedError = true;
        }
      }
    }

    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();







/* OOOOOO STUDIO footer: six individual letters + studio. */
(() => {
  function start() {
    const link = Array.from(document.querySelectorAll(
      '.shopify-section-group-footer-group .menu__item:nth-child(3) a'
    )).find(a =>
      new URL(a.href, location.href).hostname.replace(/^www\./, '') ===
      'oooooostudio.com'
    );

    if (!link || link.classList.contains('pas-ooo-link')) return;

    const colors = [
      '#8C0000',
      '#D15600',
      '#D9A300',
      '#007D00',
      '#004E80',
      '#31004D',
      '#6B3A86'
    ];

    const fragment = document.createDocumentFragment();

    colors.forEach((color, index) => {
      const span = document.createElement('span');
      span.className = 'pas-ooo-letter';
      span.textContent = index < 6 ? 'o' : ' studio';
      span.style.setProperty('--ooo-letter-color', color);
      fragment.appendChild(span);
    });

    link.classList.add('pas-ooo-link');
    link.setAttribute('aria-label', 'OOOOOO Studio');
    link.replaceChildren(fragment);
    link.addEventListener('click', () => {
  link.classList.add('pas-ooo-clicked');
});

window.addEventListener('pageshow', () => {
  link.classList.remove('pas-ooo-clicked');
});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();